var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('status-bar',{attrs:{"status":_vm.status}}),_vm._v(" "),(_vm.status==14||_vm.status==15||_vm.status==16)?_c('pass'):(_vm.status==17)?_c('sign-contract'):_c('finish')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-406b63bc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/pass-status/index.vue
// module id = null
// module chunks = 